module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/highlight.js/lib/languages/plaintext.js
// module id = 507
// module chunks = 0